import { useState } from "react";
import { Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Field } from "@/components/common";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg, SEGMENT_LABELS } from "@/lib/api";
import { toast } from "sonner";

const NUMS = [["service_fee_pct", "Taxa de serviço (%)"], ["delivery_fee", "Taxa de entrega (R$)"], ["max_discount_pct", "Desconto máximo padrão dos operadores (%)"],
  ["parking_first_hour", "Estacionamento 1ª hora (R$)"], ["parking_additional_hour", "Hora adicional (R$)"], ["parking_tolerance_min", "Tolerância (min)"], ["parking_daily_max", "Diária máxima (R$)"]];

export function CompanyParams() {
  const { session, refresh } = useAuth();
  const t = session.tenant;
  const [s, setS] = useState({ ...t.settings });
  const [segmento, setSegmento] = useState(t.segmento);
  const set = (k, v) => setS((x) => ({ ...x, [k]: v }));
  const save = async () => {
    try {
      const settings = Object.fromEntries(NUMS.map(([k]) => [k, Number(s[k]) || 0]));
      await api.put("/settings", { razao_social: t.razao_social, nome_fantasia: t.nome_fantasia, telefone: t.telefone, endereco: t.endereco, segmento,
        settings: { ...settings, stock_negative: s.stock_negative,
          ticket_logo: s.ticket_logo !== false, pickup_password_mode: s.pickup_password_mode || "off" } });
      await refresh();
      toast.success("Parâmetros salvos");
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="grid sm:grid-cols-3 gap-4" data-testid="company-params">
      <Field label="Segmento">
        <Select value={segmento} onValueChange={setSegmento}>
          <SelectTrigger data-testid="settings-segment-select"><SelectValue /></SelectTrigger>
          <SelectContent>{Object.entries(SEGMENT_LABELS).map(([k, v]) => <SelectItem key={k} value={k}>{v}</SelectItem>)}</SelectContent>
        </Select>
      </Field>
      <Field label="Venda sem estoque">
        <select value={s.stock_negative} onChange={(e) => set("stock_negative", e.target.value)} className="h-10 rounded-md border bg-transparent px-2 text-sm" data-testid="setting-stock-negative-select">
          <option value="allow">Permitir e mostrar alerta</option><option value="block">Bloquear venda sem estoque</option>
        </select>
      </Field>
      <Field label="Senha de retirada" className="sm:col-span-3">
        <select value={s.pickup_password_mode || "off"} onChange={(e) => set("pickup_password_mode", e.target.value)} className="h-10 rounded-md border bg-transparent px-2 text-sm" data-testid="setting-pickup-mode-select">
          <option value="off">Não imprimir senha</option><option value="products">Só para produtos marcados (Produtos → Disponibilidade)</option><option value="all">Em todas as vendas</option>
        </select>
      </Field>
      <label className="flex items-center justify-between rounded-lg border px-3 text-sm h-10 self-end">Imprimir logo nos tickets<Switch checked={s.ticket_logo !== false} onCheckedChange={(v) => set("ticket_logo", v)} data-testid="setting-ticket-logo-switch" /></label>
      <p className="sm:col-span-3 -mt-2 text-xs text-muted-foreground">A senha segue uma ordem única entre balcão, PDV, Venda ticket e mesa, e recomeça todo dia.</p>
      {NUMS.map(([k, label]) => <Field key={k} label={label}><Input type="number" step="0.01" value={s[k] ?? ""} onChange={(e) => set(k, e.target.value)} data-testid={`setting-${k}-input`} /></Field>)}
      <Button onClick={save} className="sm:col-span-3 h-11" data-testid="save-settings-btn"><Save className="h-4 w-4 mr-2" />Salvar parâmetros</Button>
    </div>
  );
}
